/** GraphQL query compartida para la ficha SPEC-12. */

export const GET_DOCUMENT_BY_ID_FIELDS = `
  document_id
  status
  doc_type
  key
  mimetype
  filename
  bucket
  redirect_target_document_id
  redirect_target_doc_type
  source_document_id
  qr_link
  qr_data {
    fecha
    cuit
    ptoVta
    tipoCmp
    nroCmp
    importe
    moneda
    ctz
    tipoDocRec
    nroDocRec
    tipoCodAut
    codAut
  }
  arca_validation {
    status
    severity
    result
    checked_at
    environment
    observations
    errors
    process_date
    audit_id
    retryable
    attempts
    comparison {
      key
      label
      extracted_value
      arca_value
      match
    }
  }
  fiscal_enrichment
  field_edits
  bedrock_model_output {
    metadata
  }
`;

export function buildDocumentByIdQuery(documentId) {
  return `query GetDocumentById {
    getDocumentById(id: "${documentId}") {
      ${GET_DOCUMENT_BY_ID_FIELDS}
    }
  }`;
}
